// Screen (mesh) colors the customer can choose from, the Suntex® 80 finishes.
// Images live in the gallery (via ASSETS). `hex` is only a fallback dot if an
// image is ever missing. Live gallery/S3 never overrides this static swatch set.
import { ASSETS } from './assets-data';

const COLORS = [
    { key: 'stucco',      hex: '#D9D2C5', image: ASSETS.SUNTEX_80_STUCCO,      name: { en: 'Stucco',      he: 'סטוקו' } },
    { key: 'beige',       hex: '#C7B899', image: ASSETS.SUNTEX_80_BEIGE,       name: { en: 'Beige',       he: 'בז׳' } },
    { key: 'grey',        hex: '#8A8B86', image: ASSETS.SUNTEX_80_GREY,        name: { en: 'Grey',        he: 'אפור' } },
    { key: 'brown',       hex: '#5B4636', image: ASSETS.SUNTEX_80_BROWN,       name: { en: 'Brown',       he: 'חום' } },
    { key: 'dark-bronze', hex: '#453B32', image: ASSETS.SUNTEX_80_DARK_BRONZE, name: { en: 'Dark Bronze', he: 'ברונזה כהה' } },
    { key: 'black',       hex: '#1F1F1F', image: ASSETS.SUNTEX_80_BLACK,       name: { en: 'Black',       he: 'שחור' } },
].filter((c) => c.image);

const UI = {
    en: {
        eyebrow: 'Suntex® 80 Mesh',
        title: 'Choose your screen color',
        subtitle: 'Our premium mesh comes in six finishes, pick the one that blends with your home.',
    },
    he: {
        eyebrow: 'רשת Suntex® 80',
        title: 'בחרו את צבע הרשת',
        subtitle: 'הרשת האיכותית שלנו מגיעה בשישה גוונים, בחרו את זה שמשתלב עם הבית שלכם.',
    },
};

export function getScreenColors() {
    return COLORS;
}

export function getScreenColorsUI(lang = 'en') {
    return UI[lang === 'he' ? 'he' : 'en'];
}
